/**
 * WeldIQ bulk artefacts live under live-DB project ids:
 * Ruya = 5, Golfinho Production = 4.
 * Data360 platform ids for those same projects are different (Ruya 322, Golfinho 270).
 * Statistics must try the artefact id first, then the platform id.
 */

const RUYA_WELDIQ_PROJECT_ID = 5;
const GOLFINHO_WELDIQ_PROJECT_ID = 4;

const PLATFORM_ID_TO_WELDIQ: Record<number, number> = {
  322: RUYA_WELDIQ_PROJECT_ID,
  270: GOLFINHO_WELDIQ_PROJECT_ID,
};

function normalizeProjectName(name: unknown): string {
  return String(name ?? '')
    .trim()
    .toLowerCase()
    .replace(/[’']/g, '')
    .replace(/\s+/g, ' ');
}

function asProjectId(value: number | string | null | undefined): number | string | null {
  if (value == null) return null;
  if (typeof value === 'number') return Number.isFinite(value) ? value : null;
  const text = value.trim();
  if (!text) return null;
  if (/^\d+$/.test(text)) return Number(text);
  return text;
}

function artefactIdFor(input: {
  projectId?: number | string | null;
  projectName?: string | null;
}): number | null {
  const name = normalizeProjectName(input.projectName);
  if (name === 'ruya') return RUYA_WELDIQ_PROJECT_ID;
  if (name.includes('golfinho') || name.includes('golphino')) {
    return GOLFINHO_WELDIQ_PROJECT_ID;
  }
  const platformId = asProjectId(input.projectId);
  if (typeof platformId === 'number' && PLATFORM_ID_TO_WELDIQ[platformId] != null) {
    return PLATFORM_ID_TO_WELDIQ[platformId];
  }
  return null;
}

/** Ordered WeldIQ `project_id` values to query. First hit with rows wins. */
export function weldIqProjectIdsToTry(input: {
  projectId?: number | string | null;
  projectName?: string | null;
}): Array<number | string> {
  const ids: Array<number | string> = [];
  const push = (id: number | string | null) => {
    if (id == null) return;
    if (ids.some((existing) => String(existing) === String(id))) return;
    ids.push(id);
  };
  push(artefactIdFor(input));
  push(asProjectId(input.projectId));
  return ids;
}
